(function () {
	angular
		.module('trackeye')
		.factory('Invite', _InviteFactory);

	_InviteFactory.$inject = ['Permissions', 'C4ApiService', '$q'];

	function _InviteFactory(Permissions, api, $q) {

		/**
		 * @constructor
		 */
		function Invite(name, description) {
			this.id = undefined;
			this.type = undefined;
			this.name = name;
			this.description = description;
			this.expire = undefined;
			this.links = {};
			this.permissions = new Permissions();

			this.isNew = true;
		}

		Invite.prototype.getId = function () {
			return this.id;
		};

		Invite.prototype.getType = function () {
			return this.type;
		};

		Invite.prototype.getName = function () {
			return this.name;
		};

		Invite.prototype.getDescription = function () {
			return this.description;
		};

		/**
		 * @param {string} email
		 * @returns {Invite}
		 */
		Invite.prototype.setUser = function (email) {
			this.links.users = [{email: email}];

			return this;
		};

		/**
		 * @param {Device} device
		 * @returns {Invite}
		 */
		Invite.prototype.setDevice = function (device) {
			this.links.units = [device.getPlain()];

			return this;
		};

		/**
		 *
		 * @param {string} type
		 * @param {Device} device
		 * @returns {Invite}
		 */
		Invite.prototype.setPermissions = function (type, device) {
			if (type === "read") {
				this.permissions.set(
					device.permissions.get(['read', 'list'])
				);
			} else if (type === "full") {
				this.permissions.set(
					device.permissions.get(['create', 'update', 'delete', 'read', 'list'])
				);
			}

			return this;
		};

		/**
		 * Set the expiration of an invite.
		 * @param {Date} date
		 */
		Invite.prototype.setExpire = function (date) {
			if (!(date instanceof Date)) {
				console.error('invite.setExpire: type is not instance of Date');
				return false;
			}

			var now = new Date();
			now.setHours(0);
			now.setMinutes(0);
			now.setSeconds(0);

			if (now >= date) {
				return false;
			}

			this.expire = date.toISOString();

			return true;
		};

		Invite.prototype.getUser = function () {
			return this.links.users.pop();
		};

		Invite.prototype.hasUsers = function () {
			return this.links.users && this.links.users.length;
		};

		Invite.prototype.hasDevices = function () {
			return this.links.units && this.links.units.length;
		};

		/**
		 * @returns {Array}
		 */
		Invite.prototype.getUsers = function () {
			return this.links.users || [];
		};

		/**
		 * @returns {Array}
		 */
		Invite.prototype.getDevices = function () {
			return this.links.units || [];
		};

		/**
		 * @param {String} uuid
		 * @returns {boolean}
		 */
		Invite.prototype.hasDevice = function (uuid) {
			return this.getDevices().some(function (device) {
				return device.id == uuid;
			});
		};

		Invite.prototype.hasExpire = function () {
			return !!this.expire;
		};

		Invite.prototype.getExpire = function () {
			return new Date(this.expire);
		};

		Invite.prototype.isFull = function () {
			return this.permissions.isFull();
		};

		Invite.prototype.isReadonly = function () {
			return this.permissions.isReadonly();
		};

		Invite.prototype.save = function () {
			var defer = $q.defer(),
				self = this;

			api.saveInvite(this).then(function (resp) {
				if (self.isNew) {
					self.isNew = false;
					self.id = resp.data.id;
					self.href = resp.data.href;
				}

				self.savePermissions().then(function () {
					defer.resolve(self);
				}, defer.reject);
			}, defer.reject);

			return defer.promise;
		};

		/**
		 * Save permissions for each device, attached to the invite.
		 * @returns {Promise}
		 */
		Invite.prototype.savePermissions = function () {
			var self = this,
				promises = self.getDevices().map(function (device) {
					return self.permissions.save('/invites/' + self.getId() + '/units/' + device.id + '/permissions');
				});

			return $q.all(promises);
		};

		/**
		 * This populates the object, with given data. Will also
		 * treat the object as already existing
		 * @param {object} data
		 * @returns {Invite}
		 */
		Invite.prototype.populate = function (data) {
			this.isNew = false;

			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					if (key == "expire" && data[key]) {

					}

					this[key] = data[key];
				}
			}

			/**
			 * @todo multiple device support
			 * Get permissions for device
			 * NOTE, this only accounts for ONE device per invite!
			 */

			if (this.hasDevices()) {
				var self = this,
					device_id = data.links.units[0].id;

				self.permissions.fetch('/invites/' + self.getId() + '/units/' + device_id + '/permissions');
			}

			return this;
		};

		/**
		 * Merge a copy of another invite, this is useful if
		 * you want to keep references working for this instance.
		 *
		 * @param {Invite} invite
		 */
		Invite.prototype.copy = function (invite) {
			if (!(invite instanceof Configuration))
				return;

			for (var key in invite) {
				if (invite.hasOwnProperty(key)) {
					this[key] = invite[key];
				}
			}

			return this;
		};

		return Invite;
		/*
				Invite.prototype.addDevices = function(uuid) {
					return addEntityByType(this.id, 'units', 'id', uuid);
				};
		
				Invite.prototype.addUsers = function(email) {
					return addEntityByType(this.id, 'users', 'email', email);
				};
		
				Invite.prototype.addPermission = function(uuid, unit, permission) {
		
				};
		*/
		/**
		 * Remove either user or unit by its uuid. This can be used for both
		 * types, as we know the uuid for both
		 * @param {String} type
		 * @param {Array} ids
		 * @returns {Promise}
		 */
		/*		Invite.prototype.removeById = function(type, ids) {
					var requestData = [];
		
					ids.forEach(function(uuid) {
						requestData.push({
							type: type,
							id: uuid
						});
					});
		
					return api.forward('delete', '/invites/'+this.id+'/'+type, requestData);
				};
		
				function addEntityByType(id, entity, type, typeValues) {
					var requestBody = [];
		
					if (!(typeValues instanceof Array))
						typeValues = [typeValues];
		
					typeValues.forEach(function(typeValue) {
						var requestObj = {};
		
						requestObj[type] = typeValue;
						requestObj.type = entity;
						requestBody.push(requestObj);
					});
		
					return api.forward('post', '/invites/'+id+'/'+entity, requestBody);
				}
		 */
	}
})();